import { motion, AnimatePresence, useWillChange } from "framer-motion";
import { Button, Icon, Input } from "semantic-ui-react";
import { useNavigate } from "react-router";

import { HiPhone } from "react-icons/hi";
import { IoMail } from "react-icons/io5";

import { popUpVariant } from "../../animateConstant";
import SignInUp from "../../components/SignInUp/SignInUp";
import MailSignin from "./MailSignin";
import { useEffect, useState } from "react";
import { getFixedStyle } from "../../hook/useDeviceType";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import { IoMdClose } from "react-icons/io";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { notice } from "../../redux/action/action";

const Signin = () => {
  const { t } = useTranslation();
  const i18n_backend_response = (key) => t(`backend_response.${key}`);
  const [chooseSigninMethod, setChooseSigninMethod] = useState("mail");
  const [isClosing, setIsClosing] = useState(false);

  const navigate = useNavigate();
  const previousPage = usePreviousPagePath();

  const dispatch = useDispatch();

  const willChange = useWillChange();

  useEffect(() => {
    if (Cookies.get("token")) {
      // dispatch(
      //   notice(
      //     i18n_backend_response("You are login, please logout first."),
      //     "warning"
      //   )
      // );
      navigate("/casino");
    }
  }, []);

  return (
    <>
      {/* bg-[rgba(0, 0, 0, 0.5)] */}
      {!isClosing && (
        <main
          className={`${getFixedStyle()} z-[10000] !p-0 w-[400px] h-[min(865px,70vh)] bg-base-light-white rounded-[10px] dark:bg-base-deep-black sm:backdrop-blur-none backdrop-blur-md`}
        >
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            style={{ willChange }}
            transition={{
              duration: 0.2,
            }}
            className="h-full rounded-[15px] overflow-hidden"
          >
            <section className="flex items-center justify-between h-[60px] px-[25px]">
              <SignInUp signinClass={`!bg-main-color !text-white`} />
              <IoMdClose
                onClick={() => {
                  setIsClosing(true);
                  setTimeout(() => {
                    navigate(previousPage);
                  }, 200);
                }}
                className="!mb-[8px] !text-3xl !text-light-text cursor-pointer"
              />
            </section>
            <section
              className="w-full px-common-padding-x py-[10px] !px-[25px] overflow-y-scroll no-scrollbar"
              style={{ height: "calc( 100% - 60px )" }}
            >
              {/* <div className="flex items-center justify-center mb-[30px]">
                <div
                  className={`w-[30px] h-[30px] gap-[30px] rounded bg-light-text text-second-color cursor-pointer ${
                    chooseSigninMethod === "mail" && "!bg-main-color"
                  } flex items-center justify-center mx-[38px]`}
                  onClick={() => {
                    setChooseSigninMethod("mail");
                  }}
                >
                  <IoMail className="text-2xl" />
                </div>
                <div className="w-[.5px] h-[30px] bg-gray-500"></div>
                <div
                  className={`w-[30px] h-[30px] gap-[30px] rounded bg-light-text text-second-color cursor-pointer ${
                    chooseSigninMethod === "phone" && "!bg-main-color"
                  } flex items-center justify-center mx-[38px]`}
                  onClick={() => {
                    setChooseSigninMethod("phone");
                  }}
                >
                  <HiPhone className="text-2xl" />
                </div>
              </div> */}
              {/* {chooseSigninMethod === "mail" ? <MailSignin /> : <PhoneSignin />} */}
              <MailSignin />
            </section>
          </motion.section>
        </main>
      )}
    </>
  );
};

export default Signin;
